import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

const getAuthConfig = () => {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// =====================================================
// GET BLOGS
// =====================================================

export const getBlogsApi = async (payload = {}) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/blogs/list`,
      {
        page: payload.page || 1,
        limit: payload.limit || 10,
        search: payload.search || "",
        category: payload.category || "",
        difficulty: payload.difficulty || "",
        platform: payload.platform || "",
        trending: payload.trending ?? "",
      },
      {
        ...getAuthConfig(),
        headers: {
          ...getAuthConfig().headers,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load blogs.",
    };
  }
};

// =====================================================
// BLOG STATS
// =====================================================

export const getBlogStatsApi = async () => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/blogs/stats`,
      {},
      {
        ...getAuthConfig(),
        headers: {
          ...getAuthConfig().headers,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load blog statistics.",
    };
  }
};

// =====================================================
// GET SINGLE BLOG
// =====================================================

export const getBlogApi = async (blogId) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/blogs/view`,
      { blog_id: blogId },
      {
        ...getAuthConfig(),
        headers: {
          ...getAuthConfig().headers,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to load blog.",
    };
  }
};

// =====================================================
// CREATE BLOG
// =====================================================

export const createBlogApi = async (
  payload = {}
) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/blogs/create`,
      {
        blog_title: payload.blog_title || "",
        blog_meta_title: payload.blog_meta_title || "",
        blog_keyword: payload.blog_keyword || "",
        blog_parent: payload.blog_parent ?? "",
        blog_parent_type: payload.blog_parent_type || "",
        blog_cat: payload.blog_cat ?? "",
        blog_diff_level: payload.blog_diff_level || "",
        blog_desc: payload.blog_desc || "",
        blog_content: payload.blog_content || "",
        blog_duration: payload.blog_duration ?? "",
        blog_creator: payload.blog_creator ?? "",
        blog_image: payload.blog_image || "",
        blog_platform: payload.blog_platform || "",
        blog_is_trending: payload.blog_is_trending ? "1" : "0",
      },
      {
        ...getAuthConfig(),
        headers: {
          ...getAuthConfig().headers,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to create blog.",
    };
  }
};

// =====================================================
// UPDATE BLOG
// =====================================================

export const updateBlogApi = async (
  payload = {}
) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/blogs/update`,
      {
        blog_id: payload.blog_id ?? "",
        blog_title: payload.blog_title || "",
        blog_meta_title: payload.blog_meta_title || "",
        blog_keyword: payload.blog_keyword || "",
        blog_parent: payload.blog_parent ?? "",
        blog_parent_type: payload.blog_parent_type || "",
        blog_cat: payload.blog_cat ?? "",
        blog_diff_level: payload.blog_diff_level || "",
        blog_desc: payload.blog_desc || "",
        blog_content: payload.blog_content || "",
        blog_duration: payload.blog_duration ?? "",
        blog_creator: payload.blog_creator ?? "",
        blog_image: payload.blog_image || "",
        blog_platform: payload.blog_platform || "",
        blog_is_trending: payload.blog_is_trending ? "1" : "0",
      },
      {
        ...getAuthConfig(),
        headers: {
          ...getAuthConfig().headers,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to update blog.",
    };
  }
};

// =====================================================
// DELETE BLOG
// =====================================================

export const deleteBlogApi = async (
  blogId
) => {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/blogs/delete`,
      { blog_id: blogId },
      {
        ...getAuthConfig(),
        headers: {
          ...getAuthConfig().headers,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (error) {
    return {
      status: false,
      type: "danger",
      success:
        error?.response?.data?.success ||
        "Unable to delete blog.",
    };
  }
};